import React, { createContext } from 'react';
const I18nContext = createContext(null);
export { I18nContext };
